import styled from "@emotion/styled";

const CentreCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export { CentreCard };
